export default {"src":"/_next/static/media/IMG_9295.a1e9215e.JPG","height":1481,"width":2222};